import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { authInterceptorProviders } from './core/interceptors/auth.interceptor';

// Pour le format des dates dans les formulaires d'opérations CRUD
import { defineLocale } from 'ngx-bootstrap/chronos';
import { frLocale } from 'ngx-bootstrap/locale';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { AuthGuardService } from './core/guards/auth-guard.service';
import { cacheInterceptorProviders } from './core/interceptors/cache.interceptor';
import { httpErrorInterceptor } from './core/interceptors/http-error.interceptor';
// Importez les locales nécessaires
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';

// Enregistrez le locale français
registerLocaleData(localeFr);

defineLocale('fr', frLocale);

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		CoreModule,
		SharedModule,
		BrowserAnimationsModule
	],
	providers: [
		authInterceptorProviders,
		cacheInterceptorProviders,
		httpErrorInterceptor,
		AuthGuardService,
		{ provide: LOCALE_ID, useValue: 'fr-FR' }
	],
	bootstrap: [AppComponent]
})
export class AppModule {
	constructor(private localeService: BsLocaleService) {
		// Pour le format des dates dans les formulaires d'opérations CRUD
		this.localeService.use('fr');
	}
}
